define('view/people/contact.detail.view',['require','exports','module','uikit/uikit','backbone.radio','fukit/fukit','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var UIKit       = require('uikit/uikit'),
      Radio       = require('backbone.radio'),
      RolesHelper = require('fukit/fukit').RolesHelper,
      ROLES       = require('fukit/fukit').Roles;

  //behaviors
  // var AuthorizationBehavior                         = require('behavior/authorization.behavior');

  var ProfileDetailsView = UIKit.ItemView.extend({
    template: 'people.contact.detail',

    internalViewOptions: {
      formView: {
        type: UIKit.Form,
        showValidationMessage: false,
        showFieldValidationMessage: true,
      },
      email: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'email',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: [
          //       {
          //         filter: function() {
          //           return true
          //         },
          //         message: function() {
          //           return 'You do not have permission to edit this' + ((RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ'])) ? ' page.' : '.');
          //         },
          //         roles: [ROLES.PERSON_PROFILE_UPDATE]
          //       }
          //     ],
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      phone: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'phone',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: [
          //       {
          //         filter: function() {
          //           return true
          //         },
          //         message: function() {
          //           return 'You do not have permission to edit this' + ((RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ'])) ? ' page.' : '.');
          //         },
          //         roles: [ROLES.PERSON_PROFILE_UPDATE]
          //       }
          //     ],
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      fax: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'fax',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: [
          //       {
          //         filter: function() {
          //           return true
          //         },
          //         message: function() {
          //           return 'You do not have permission to edit this' + ((RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ'])) ? ' page.' : '.');
          //         },
          //         roles: [ROLES.PERSON_PROFILE_UPDATE]
          //       }
          //     ],
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      streetAddress1: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'streetAddress1',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: [
          //       {
          //         filter: function() {
          //           return true
          //         },
          //         message: function() {
          //           return 'You do not have permission to edit this' + ((RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ'])) ? ' page.' : '.');
          //         },
          //         roles: [ROLES.PERSON_PROFILE_UPDATE]
          //       }
          //     ],
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      streetAddress2: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'streetAddress2',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: [
          //       {
          //         filter: function() {
          //           return true
          //         },
          //         message: function() {
          //           return 'You do not have permission to edit this' + ((RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ'])) ? ' page.' : '.');
          //         },
          //         roles: [ROLES.PERSON_PROFILE_UPDATE]
          //       }
          //     ],
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      countryId: function() {
        return {
          type: UIKit.Input,
          model: this.country,
          bindings: {
            value: 'name',
          },
          // typeAheadFind: true,
          // placeholder: 'Search...',
          // icon: 'search',
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: [
          //       {
          //         filter: function() {
          //           return true
          //         },
          //         message: function() {
          //           return 'You do not have permission to edit this' + ((RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ'])) ? ' page.' : '.');
          //         },
          //         roles: [ROLES.PERSON_PROFILE_UPDATE]
          //       }
          //     ],
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      countrySubdivisionId: function() {
        return {
          type: UIKit.Input,
          model: this.subdivision,
          bindings: {
            value: 'name',
          },
          // typeAheadFind: true,
          // placeholder: 'Search...',
          // icon: 'search',
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: [
          //       {
          //         filter: function() {
          //           return true
          //         },
          //         message: function() {
          //           return 'You do not have permission to edit this' + ((RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ'])) ? ' page.' : '.');
          //         },
          //         roles: [ROLES.PERSON_PROFILE_UPDATE]
          //       }
          //     ],
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      city: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'city',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: [
          //       {
          //         filter: function() {
          //           return true
          //         },
          //         message: function() {
          //           return 'You do not have permission to edit this' + ((RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ'])) ? ' page.' : '.');
          //         },
          //         roles: [ROLES.PERSON_PROFILE_UPDATE]
          //       }
          //     ],
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
      postalCode: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'postalCode',
          },
          // behaviors: {
          //   AuthorizationBehavior: {
          //     enableOnlyWhen: [
          //       {
          //         filter: function() {
          //           return true
          //         },
          //         message: function() {
          //           return 'You do not have permission to edit this' + ((RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ'])) ? ' page.' : '.');
          //         },
          //         roles: [ROLES.PERSON_PROFILE_UPDATE]
          //       }
          //     ],
          //     behaviorClass: AuthorizationBehavior
          //   }
          // }
        };
      },
    },

    onInjectedFormView: function() {
      var emailInput = this.buildComponent({ name: 'email' });
      var phoneInput = this.buildComponent({ name: 'phone' });
      var faxInput = this.buildComponent({ name: 'fax' });
      var streetAddress1Input = this.buildComponent({ name: 'streetAddress1' });
      var streetAddress2Input = this.buildComponent({ name: 'streetAddress2' });
      var countryIdInput = this.buildComponent({ name: 'countryId' });
      var countrySubdivisionIdInput = this.buildComponent({ name: 'countrySubdivisionId' });
      var cityInput = this.buildComponent({ name: 'city' });
      var postalCodeInput = this.buildComponent({ name: 'postalCode' });

      this.bindOption('model', 'model', this.formView);
      this.formView
        .addGroup()
        .addField({ text: 'Email' }, emailInput)
        .parent()
        .addField({ text: 'Phone' }, phoneInput)
        .parent()
        .addField({ text: 'Fax' }, faxInput)
        .parent()
        .parent()
        .addField({ text: 'Street 1' }, streetAddress1Input)
        .parent()
        .addField({ text: 'Street 2' }, streetAddress2Input)
        .parent()
        .addGroup()
        .addField({ text: 'Country' }, countryIdInput)
        .parent()
        .addField({ text: 'State/Province' }, countrySubdivisionIdInput)
        .parent()
        .addField({ text: 'City' }, cityInput)
        .parent()
        .parent()
        .addGroup()
        .addField({ text: 'Postal Code' }, postalCodeInput);
    },
  });
  module.exports = ProfileDetailsView;
});

